import CollectGraphicsGrid from "./collect-graphics-grid";

import "./collect-graphics-grids.scss";

const CollectGraphicsGrids = {
    All : CollectGraphicsGrid
};

export default CollectGraphicsGrids;